import RestApiModel from "@/api/Model/RestApiModel";

class DocumentType extends RestApiModel {
  static getResourceEndpoint() {
    return '/CommercialDocumentTypes';
  }
}

export default DocumentType;
